'use strict';
'use client';
import { j as l } from "../../external/react/jsx-runtime.js";
import { faPlus as u } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import { FontAwesomeIcon as f } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import n from "../../external/classnames/index.js";
import i from "html-react-parser";
import { useRef as g, useEffect as h } from "react";
import { useTheme as p } from "../Provider/index.js";
const N = ({
  title: d,
  isActive: o = !1,
  onClick: s,
  content: a
}) => {
  const e = g(null), { isMosh: t, isMoshy: r } = p();
  return h(() => {
    o && setTimeout(() => {
      if (e != null && e.current && // Check if the accordion is not in view or larger than the viewport
      (e.current.clientHeight > window.innerHeight || e.current.getBoundingClientRect().top < 0)) {
        const m = e.current.getBoundingClientRect().top + window.pageYOffset - 16;
        window.scrollTo({
          top: m,
          behavior: "smooth"
        });
      }
    }, 100);
  }, [o]), /* @__PURE__ */ l.jsxs(
    "div",
    {
      ref: e,
      className: n("rounded-2xl", {
        "bg-green-light": t && o,
        "bg-yellow-light": r && o
      }),
      "data-expanded": o,
      "data-testid": "accordion-item",
      children: [
        /* @__PURE__ */ l.jsxs(
          "button",
          {
            className: n(
              "flex justify-between items-start gap-3 w-full text-left",
              "cursor-pointer py-3 my-1 transition-all duration-200 rounded-2xl",
              "hover:py-4 hover:px-4 hover:my-0 hover:gap-5",
              {
                "hover:font-demi hover:bg-green-light": t,
                "hover:font-semibold hover:bg-yellow-light": r,
                "font-demi": o && t,
                "font-semibold": o && r,
                "px-4": o,
                "px-6": !o
              }
            ),
            "aria-expanded": o,
            "aria-controls": "accordion-content",
            onClick: () => {
              s && s();
            },
            children: [
              i(d),
              /* @__PURE__ */ l.jsx(
                f,
                {
                  icon: u,
                  "data-active": o,
                  size: "xl",
                  className: n(
                    "transition-all duration-200",
                    o ? "rotate-[135deg]" : "rotate-0"
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ l.jsx(
          "div",
          {
            className: n(
              "px-4 transition-all duration-200 text-left rounded-2xl",
              "[&_ol]:ml-4 [&_ol]:mb-2 [&_ol]:break-words",
              "[&_ol_a]:break-all",
              "[&_ul]:ml-6 [&_ul]:list-disc [&_ul]:list-outside",
              "[&_a]:underline",
              {
                "bg-green-light": t,
                "bg-yellow-light": r,
                "h-0 overflow-hidden": !o,
                "h-auto pb-4": o
              }
            ),
            role: "region",
            children: typeof a == "string" ? i(a) : a
          }
        )
      ]
    }
  );
};
export {
  N as default
};
